<template>
  <div>
    <div style="height: 50px;background-color: #fafbfc"></div>
    <div style="padding: 10px 40px 20px">
      <div class="title_div" style="padding: 16px 5px 16px 30px;margin-bottom: 16px;display: flex;justify-content: space-between;align-items: center;background: rgba(248,249,251,0.62); ">
        <div class="title_content" style="display: flex;align-items: center">
          <div style="font-size: 12px;color: #999999;margin-right: 17px;">{{ $t('keygengxinshuoming') }}</div>
          <div>
            <pt-select :allow-clear="false" @change="selectByDate" style="width: 150px"  v-model="selectDate">
              <a-select-option v-for="(item,index) in dates" :key="item">{{item}}</a-select-option>
            </pt-select>
          </div>
        </div>
        <div class="title_content" style="display: flex;align-items: center" v-if="updateInfo.appUpdate == 1">
          <span style="font-size: 12px;color: #333333">{{ $t('bmsappshaomaxiazai') }}</span>
          <img src="@/assets/bmsAPPqrcode.jpeg" alt="">
        </div>
      </div>
      <div class="content" style="background: rgba(248,249,251,0.62);border-radius: 0 0 4px 4px;">
        <div class="content_div version_update_content" style="padding: 30px;">
          <div  v-html="updateInfo.content"></div>
        </div>
      </div>
    </div>
    <div style="height: 30px;"></div>
  </div>

</template>

<script>
  import Api from '@/api/sys/updateInfo'
  import moment from 'moment'
  export default {
    name: 'updateInfo',
    data() {
      return {
        visible: false,
        updateInfo: {
          appUpdate:0,
        },
        dates:[],
        selectDate:'',
      }
    },
    mounted() {
      this.initData()
      this.getSelectData()
    },
    methods: {
      getSelectData(){
        Api.selectAllPicker().then(res=>{
          if(res.code == 1){
            this.dates = res.data;
          }
        })
      },
      selectByDate(){
        Api.getByDate(this.selectDate).then(res => {
          if (res.code == 1) {
            if (res.data) {
              this.updateInfo = res.data
            }
          }
        })
      },
      initData() {
        Api.getNewUpdateInfo().then(res => {
          if (res.code == 1) {
            if (res.data) {
              this.updateInfo = res.data
              this.selectDate = moment(res.data.createTime).format("YYYY-MM-DD")
            }
          }
        })
      }
    }

  }
</script>
<style>
  .version_update_content{
    font-size: 14px;
    color: #323232;
  }
</style>
<style lang="less">
  .update_info {
    .title_div {
      background-image: url("~@/assets/update.png");
      height: 134px;
      background-size: cover;
      text-align: left;

      .title_content {
        display: flex;
        padding-left: 67px;
        flex-direction: column;
        height: 134px;
        justify-content: center;
        align-content: center;

        div:first-child {
          font-size: 24px;
          color: #FFFFFF;
        }

        div:last-child {
          padding-top: 8px;
          font-size: 12px;
          color: #999999;
        }
      }
    }

    .ant-modal-header {
      padding: 0px;
    }

    .ant-modal {
      top: 60px !important;
      padding-bottom: 0px !important;
    }

    .ant-modal-close-x {
      color: #ffffff;
      font-size: 20px !important;
    }

    .ant-modal-body {
      padding: 0px !important;
    }

    .content {
      height: 360px;
      padding: 35px 67px 0px;
      overflow-y: auto;

      .content_div {
        text-align: justify;

        .item {
          font-weight: bold;
          font-size: 14px;
          margin-bottom: 15px;
        }

        .update_info_content {
          ol {
            margin-left: -25px;
            line-height: 15px;
          }
        }
      }

    }
  }
</style>
